export default __webpack_public_path__ + "static/media/ser7.6c347d14.svg";